import { ResultSet } from '@cubejs-client/core'
import { CubeQuery, useCubeQuery } from '@driftt/dds.reports'

const decodeHtmlEntities = (html: string): string => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html
  return textarea.value
}

export interface ScenarioExecutionsData {
  scenarioMessage: string
  scenarioId: string
  scenarioName: string
  scenarioType: string
  triggeringMessageId: string
  conversationId: string
}

const useScenarioExecutionsWithData = (scenarioId: string) => {
  const query: CubeQuery = {
    name: 'ScenarioTriggeringPhrases',
    queryName: 'ScenarioTriggeringPhrases',
    query: {
      dimensions: [
        'DriftChatScenarioExecutions.scenarioId',
        'DriftChatScenarioExecutions.scenarioName',
        'DriftChatScenarioExecutions.chatMessageBody',
        'DriftChatScenarioExecutions.conversationId',
        'DriftChatScenarioExecutions.triggerMessageId',
        'DriftChatScenarioExecutions.scenarioType',
        'DriftChatScenarioExecutions.skillCompletedAt',
      ],
      filters: [
        {
          dimension: 'DriftChatScenarioExecutions.scenarioId',
          operator: 'equals',
          values: [scenarioId],
        },
      ],
      order: {
        'DriftChatScenarioExecutions.skillCompletedAt': 'desc',
      },
    },
  }
  const { data, isLoading, isError } = useCubeQuery({
    query: query,
  })

  if (isError) {
    console.error('Error fetching scenario executions', isError)
  }

  const scenarioExecutionsData: ScenarioExecutionsData[] = ResultSet
    ? (data?.tablePivot() || []).map((row) => ({
        scenarioMessage: decodeHtmlEntities(
          row['DriftChatScenarioExecutions.chatMessageBody'] as string
        ),
        scenarioId: row['DriftChatScenarioExecutions.scenarioId'] as string,
        scenarioName: row['DriftChatScenarioExecutions.scenarioName'] as string,
        triggeringMessageId: row[
          'DriftChatScenarioExecutions.triggerMessageId'
        ] as string,
        conversationId: row[
          'DriftChatScenarioExecutions.conversationId'
        ] as string,
        scenarioType: row['DriftChatScenarioExecutions.scenarioType'] as string,
      }))
    : []

  return { scenarioExecutions: scenarioExecutionsData, isLoading, isError }
}

export default useScenarioExecutionsWithData
